import React from "react";
import { Link } from "react-router-dom";
import FadeOnScroll from "./FadeOnScroll";
import CardHoverEffect from "./CardHoverEffect";

const OurProcess = () => {
  return (
    <div className="w-full min-h-screen bg-[#f5f3eb] dark:bg-[#1c1c1c] relative">
      
      {/* Hero Section */}
      <FadeOnScroll>
        <div className="flex items-center justify-center min-h-screen px-8 py-16">
          <header className="flex lg:flex-row flex-col items-center gap-[50px] lg:gap-0">
            <div className="max-w-2xl">
              <h1 className="text-[40px] lg:text-[60px] leading-[45px] lg:leading-[65px] text-center lg:text-left text-[#4b534e] dark:text-white">
                Our Collaborative Process
              </h1>
              <p className="text-[18px] mt-4 text-center lg:text-left text-[#7fc7e6] dark:text-gray-400">
                We take pride in crafting solutions that align perfectly with your vision. 
                From the initial consultation to final deployment, our process ensures transparency and efficiency.
              </p>

              {/* Updated Buttons with FAQ & Contact Links */}
              <div className="flex items-center flex-wrap lg:justify-start justify-center gap-5 mt-8">
                <Link to="/faq">
                  <button className="px-6 py-2 bg-[#4b534e] text-white dark:bg-[#e5471f] rounded-md shadow-md hover:opacity-80 transition">
                    Find Out More
                  </button>
                </Link>
                <Link to="/contact">
                  <button className="px-6 py-2 border border-[#4b534e] text-[#4b534e] dark:text-white dark:border-[#e5471f] rounded-md shadow-md hover:bg-[#4b534e] hover:text-white dark:hover:bg-[#e5471f] transition">
                    Contact Us
                  </button>
                </Link>
              </div>
            </div>

            {/* Hero Image (Fixed Visibility & Alignment) */}
            <div className="flex justify-center lg:w-[55%] w-full">
              <img 
                src="/assets/process-hero2.png" 
                alt="Our Process" 
                className="w-full lg:w-[550px] opacity-100 transition-opacity duration-700 ease-in-out"
              />
            </div>
          </header>
        </div>
      </FadeOnScroll>

      {/* Process Steps Section */}
      <FadeOnScroll>
        <div className="container mx-auto px-6 py-20">
          <h2 className="text-4xl font-bold text-center text-[#4b534e] dark:text-white mb-12">
            Explore Our Key Steps
          </h2>
          <CardHoverEffect />
        </div>
      </FadeOnScroll>

    </div>
  );
};

export default OurProcess;


